import type { SubmittedDocument } from "~/types/SubmittedDocument";

type SubmittedDocumentProfileFields = Pick<
  SubmittedDocument,
  "profileId" | "userProfileId"
>;

export const isCompanionSubmittedDocument = (
  document: SubmittedDocumentProfileFields
) =>
  (typeof document.profileId === "string" &&
    document.profileId.trim().length > 0) ||
  (typeof document.userProfileId === "string" &&
    document.userProfileId.trim().length > 0);
